export default __webpack_public_path__ + "static/media/noProject.6f690ded.svg";